var globalSearch = function (form, input) {
  var autocomplete = new Autocomplete(form, {
    input,
  });

  var { $form } = autocomplete;
  var $latFrom = $form.find('input[name="hotel_latitude-from"]');
  var $latTo = $form.find('input[name="hotel_latitude-to"]');
  var $lngFrom = $form.find('input[name="hotel_longitude-from"]');
  var $lngTo = $form.find('input[name="hotel_longitude-to"]');
  var coordinatesAreSet = false;

  $form.on('submit', function (e) {
    if (!coordinatesAreSet) {
      e.preventDefault();
      autocomplete.getCoordinates(autocomplete.$input.val(), function (coordinates) {
        setLatLng(coordinates, function () {
          coordinatesAreSet = true;
          $form.submit();
        });
      });
    }
  });

  function setLatLng(coordinates, callback) {
    $latFrom.val(`"${coordinates.lat.from}"`);
    $latTo.val(`"${coordinates.lat.to}"`);
    $lngFrom.val(`"${coordinates.lng.from}"`);
    $lngTo.val(`"${coordinates.lng.to}"`);
    callback();
  }
};

window.globalSearch = globalSearch;
